import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Studies } from '../../recruiters/model/recruiter.model';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';
import { map } from 'rxjs/operators';
import { NotifierService } from 'angular-notifier';
import { Router } from '@angular/router';
import { surveyPanelService } from 'src/app/serveypanel/survey-panel-service/survey-panel.service';




@Injectable({
  providedIn: 'root'
})
export class StudiesService {
  // FETCH_STUDIES_API = environment.apiUrl + '/v2/api/studies';
  // ASSIGN_STUDY_RECRUITER =  environment.apiUrl + '/v2/recruiter/study/assign';
  // GET_STUDY_BY_RECRUITER =  environment.apiUrl + '/v2/recruiter/study/';
  // ASSIGN_BULK_RECRUITER_STUDY = environment.apiUrl + '/v2/study/recruiters/assign';
  // CREATE_STUDY = environment.apiUrl + '/v2/api/studyCreate';
  // UPDATE_STUDY = environment.apiUrl + '/v2/api/studyUpdate';
  // BI_REPORT =  environment.apiUrl + '/v2/bi/';

  FETCH_STUDIES_API = '/v2/api/studies';
  ASSIGN_STUDY_RECRUITER =  '/v2/recruiter/study/assign';
  GET_STUDY_BY_RECRUITER =  '/v2/recruiter/study';
  ASSIGN_BULK_RECRUITER_STUDY = '/v2/study/recruiters/assign';
  CREATE_STUDY = '/v2/api/studyCreate';
  UPDATE_STUDY = '/v2/api/studyUpdate';
  BI_REPORT =  '/v2/bi';

  httpPostOptions =
    {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      withCredentials: true
    };

  private apiRequestHttpOptions:any = {
    httpOptions:this.httpPostOptions
  };

  public surveyList:any = [];
  public filteredSurveyList:any = [];

  constructor(private http: HttpClient,
    private notification: NotifierService,
    private router: Router,
    private surveyService: surveyPanelService, 
    private apiRequest: ApiRequestService) { }

  fetchStudies () {
    return this.apiRequest.request('POST',this.FETCH_STUDIES_API,{},this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<Studies>(this.FETCH_STUDIES_API,{ }, this.httpPostOptions);
  }
  assignStudy(payload) {
    return this.apiRequest.request('POST',this.ASSIGN_STUDY_RECRUITER,payload,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.ASSIGN_STUDY_RECRUITER, payload, this.httpPostOptions);
  }
  getStudyByRecruiter(id) {
    let pathUrl = this.GET_STUDY_BY_RECRUITER + '/' + id
    return this.apiRequest.request('GET',pathUrl,{},this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.get<any>(this.GET_STUDY_BY_RECRUITER + id, this.httpPostOptions);
  }
  getBIReport(id) {
    let pathUrl = this.BI_REPORT + '/' + id
    return this.apiRequest.request('GET',pathUrl,{},this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.get<any>(this.BI_REPORT+id, this.httpPostOptions);
  }
  assignStudyToMultipleRecruiter(payload){
    return this.apiRequest.request('POST',this.ASSIGN_BULK_RECRUITER_STUDY,payload,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.ASSIGN_BULK_RECRUITER_STUDY, payload, this.httpPostOptions);
  }
  createStudy(data: any){
    return this.apiRequest.request('POST',this.CREATE_STUDY,data,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.CREATE_STUDY, data, this.httpPostOptions);
  }
  updateStudy(data: any){
    return this.apiRequest.request('POST',this.UPDATE_STUDY,data,this.apiRequestHttpOptions).pipe(map(data => {
      let _data:any = data;
      return _data;
    }));
    // return this.http.post<any>(this.UPDATE_STUDY, data, this.httpPostOptions);
  }

  loadsurvey(search, option?: any) {
    const sdata = {"limit":24,"search": search };
    this.surveyList = [];
    this.surveyService.getAllServeys(sdata).subscribe(data => {
      if (data['errorMessage'] == "") {

        data['result'].forEach(element => {
          this.surveyList.push(element);
        });   

        if (search != '') {
          setTimeout(() =>{
            this.filteredSurveyList = this.surveyList.filter(option => (option['survey']['name'].toLowerCase().includes(search)) || (option['survey']['api_survey_id'].toString().includes(search)));
          },200)
        }else{
          this.filteredSurveyList = this.surveyList.filter(option => true);
        }
        if (option && option.isLinkedSurvey) {
          this.checkLinkedSurvey(option.survey)
        }
      }else{
        this.notification.notify("info", "NO data found!");
      }
    },error =>{
      if(error.status == 401){
        this.notification.notify("error", "User is not authorised");
        this.router.navigate(['home/access-denied']);
      }else{
        this.notification.notify("error", "Something went wrong!");
      }
    });
  }

  checkLinkedSurvey(survey){
    let isSurvey = this.surveyList.find(option => {option['survey']['uuid'] == survey.uuid});
    if (!(isSurvey && Object.keys(isSurvey) && Object.keys(isSurvey).length > 0)) {
      this.surveyList.push({"survey":survey});
      this.filteredSurveyList = this.surveyList.filter(option => true);
    }
  }
}
